// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2286b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/img/bg-light.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/img/bg-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --bs-primary-rgb:227,6,19!important;
    --bs-primary:#e30613!important;
    --bs-body-font-size:1rem!important;
    --bs-primary-rgb:227,6,19!important;
    --bs-body-line-height:1.1!important;
    --bs-link-color-rgb:227,6,19!important;    
} 
.accordion-button:not(.collapsed){
  background-color: rgba(227,6,19,0.2)!important;
  color:#000000!important;
  box-shadow: none!important
}
.accordion-button:focus {box-shadow: none!important}
.w-90{width:91%}
.vdots{z-index:999999}
.vdots .dropdown-toggle::after {
  display: none !important; 
}
.bg-gradient-transparent{
  background: rgb(0,0,0);
background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);
}
.dropdown-item.active, .dropdown-item:active {
  background-color: var(--bs-primary)!important;
}
.nav-link{
  font-size:16px!important;
}
.h1,h1,h2,h3,h4,h5,h6{
  font-family: 'Barlow Medium', 'Arial Narrow', Arial, sans-serif!important;
}
.MuiButton-root{
 font-family: 'Barlow Medium', 'Arial Narrow', Arial, sans-serif!important;
}
.h6,h6{font-size: 0.813rem!important}
h5{font-size:1rem!important}
.card-img-overlay{background-color:transparent!important;}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___})!important;
}

body,p{line-height:1.1!important;font-size:0.9rem!important;}
[data-bs-theme=light] {

.MuiListItemButton-root, MuiListItemIcon-root {
    color: var(--bs-black);
    background-color: var(--bs-white);
  }

  --bs-link-color: #e30613!important;
  --bs-link-color-rgb: 227, 6, 19!important;  
  --bs-link-hover-color: #9c000a;
  --bs-link-hover-color-rgb: 156, 0, 10!important;
  --bs-primary-rgb:227, 6, 19!important;  
  .btn.show{border:1px solid #e30613;background-color: transparent;color:#000000}

    .navbar-nav .nav-link.active{color: #e30713}
    
    .nav-link:hover{color: #e30713}
    .card:hover {box-shadow: 0 0 15px rgba(0,0,0,.3)!important; }
    .bg-toggle{background-color: var(--bs-white);}    

    .btn-primary{
    --bs-btn-color: #fff;
    --bs-btn-bg: #e30713!important;
    --bs-btn-border-color: #e30713!important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #e30712da!important;
    --bs-btn-hover-border-color: #ca200a!important;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #ca270a!important;
    --bs-btn-active-border-color: #be0d0a!important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #fd2d0d!important;
    --bs-btn-disabled-border-color: #fd0d0d!important;
}
.btn-light{
  --bs-btn-bg:rgba(255,255,255,0.85)!important;
}
.text-primary {
    color:#e30613!important;
}

.form-check-input:checked {
    background-color: #e30713;
    border-color: #e30713;
  }
  .text-bg-primary {
    color: #fff !important;
    background-color: RGBA(var(--bs-primary-rgb),var(--bs-bg-opacity,1)) !important;
  }
  .text-bg-heading {
    color: var(--bs-gray-800);
    font-weight: bold;
    background: rgb(255,255,255);
    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 51%, rgba(242,242,242,1) 90%);     
}
  .btn-outline-primary {
    --bs-btn-color: var(--bs-primary)!important;
    --bs-btn-border-color: var(--bs-primary)!important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: var(--bs-primary)!important;
    --bs-btn-hover-border-color: var(--bs-primary)!important;
    --bs-btn-focus-shadow-rgb: 13,110,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: var(--bs-primary)!important;
    --bs-btn-active-border-color: var(--bs-primary)!important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: var(--bs-primary)!important;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: var(--bs-primary)!important;
    --bs-gradient: none;
  }
  .content-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

[data-bs-theme=dark] {
  
  .MuiListItemButton-root, MuiListItemIcon-root {
    color: var(--bs-white);
    background-color: var(--bs-dark);
  }
    --bs-link-color-rgb:227,6,19!important;

    .btn{
      background-color: var(--bs-gray-900);
      color:var(--bs-gray-300);
      border:0;
    }
    .btn:hover{
      background-color: var(--bs-gray-800);
      color:var(--bs-gray-300);
      border:0;
    }
    .card:hover {box-shadow: 0 0 15px rgba(255,255,255,.5)!important; }

    .text-primary {
        color:#e30613!important;
    }
   .bg-toggle{background-color: var(--bs-gray-900);}   
  .bg-light{
      background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
   }
   

   .btn-primary{
    --bs-btn-color: #fff;
    --bs-btn-bg: #e30713!important;
    --bs-btn-border-color: #e30713!important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #e30712da!important;
    --bs-btn-hover-border-color: #ca200a!important;
    --bs-btn-focus-shadow-rgb: 49, 132, 253!important;
    --bs-btn-active-color: #fff!important;
    --bs-btn-active-bg: #ca270a!important;
    --bs-btn-active-border-color: #be0d0a!important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125)!important;
    --bs-btn-disabled-color: #fff!important;
    --bs-btn-disabled-bg: #fd2d0d!important;
    --bs-btn-disabled-border-color: #fd0d0d!important;
  }
  .lead{color:aliceblue}
  .form-check-input:checked {
    background-color: #e30713;
    border-color: #e30713;
  }
  .bg-header {
    --bs-bg-opacity: 1;
    background-color: var(--bs-black)!important;
  }
  .content-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  .rti--container{
    --rti-bg: none;
    --rti-border: var(--bs-gray-700);
  }
  .rti--tag{
    --rti-tag: var(--bs-gray-700);
  }
  .nav-pills .nav-link{background-color: var(--bs-gray-900); color:#ccc}
  
}


.grid {
display: grid;
grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
grid-gap: 0.25rem;
}
.grid > div {
background: white;
border:1px solid  var(--bs-gray-300);
padding: 0.1rem;
display: grid;
place-items: center;
}
.grid > div::before {
content: "";
display: block;
padding-bottom: 100%;
grid-area: 1/1/2/2;
}
.grid > div img {
width: 100%;
grid-area: 1/1/2/2;
}

.slim-scrollbar {
    padding: 0;
      padding-left: 0px;
    overflow-y: auto;
    direction: ltr;
    overflow-x: hidden;
    scrollbar-color: #e30613 #e4e4e4;
    scrollbar-width:none;
  }
  .slim-scrollbar::-webkit-scrollbar {width: 0;}
 
  #sidebar .sidebar-left, #rsidebar {overflow: hidden;}
  
  .slim-scrollbar.mh-50{max-height: 50vh;}
  .slim-scrollbar.mh-55{max-height: 57vh;}
  .slim-scrollbar.mh-60{max-height: 60vh;}
  .slim-scrollbar.mh-62{max-height: 62vh;}
  .slim-scrollbar.mh-70{max-height: 70vh;}
  .slim-scrollbar.mh-80{max-height: 80vh;}

  small, .small {
    font-size: 0.70em!important;
    line-height: 1 !important;
  }

  .bg-header {
  --bs-bg-opacity: 1;
  background-color: var(--bs-gray-200)!important;
}


.nav-tabs .nav-link {
  background-color: #ebebeb !important;
  color: #000000 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: solid 2px rgb(188, 188, 188) !important;
}

.nav-tabs .nav-link.active {
  border-bottom: solid 2px rgb(227, 6, 19) !important;
  background-color: #fff !important;
}

.ck-powered-by{display:none}
figure img{width:100%; height:auto!important;}

.accordion-button{padding: 10px 10px!important}

.hover-zoom {
 
}
.card-hover, .card-hover2{
  overflow:hidden;
}

.card-hover2 .card-img-overlay{display: none;}
.card-hover:hover img{
  border:2px solid red;
  transform:scale(1.2);

}
.card-hover2:hover .card-img-overlay{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

}

/* .modal-open {
  overflow: scroll!important;
} */

hr.solid {
  border-top: 4px solid #e30613;
  width: 70px;
  margin: auto;
}
.list-group-item.active {
color:#000000;
border-color:var(--bs-border-color);
background: #fff;
}
ul li, ol li{margin-bottom:10px}



#step1,#step2,#step3,#step4{
  min-height: 85vh;
}
option:checked { box-shadow: 0 0 10px 100px var(--bs-primary) inset; } 


.form-check-input:checked[type="radio"] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}
#uncontrolled-tab-example-tabpane-home ul li{margin-bottom:0!important}
#step4 ul li{margin-bottom:0!important}

.chat-button{
  z-index:999999999999;
  position: fixed!important;
  right: 10px!important;
  bottom: 10px!important;
  
}
.chat-button:hover{box-shadow: 0px 0px 10px #ccc;}

#libraryBanner:hover{
  cursor: pointer;
}
#libraryBanner{width:100%}

.MuiButton-startIcon{margin-right:0!important}
.profile-grid {
  display: grid;
  grid-template-columns:  auto auto auto; 
  grid-gap: 0.75rem;
  }

  .profile-grid-2-cols {
    display: grid;
    grid-template-columns:  auto auto; 
    grid-gap: 0.75rem;
    }
  
  .bic-rounded-top {
    border-top-left-radius: 15px !important;
    border-top-right-radius: 15px !important;
  }

  .zoom {
    box-shadow: 20px 20px 41px rgba(10,10,10,.15);
  }

  .zoom:hover {
    transform: scale(1.019); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    transform-origin: 0% 0;
    box-shadow: 20px 20px 41px rgba(10,10,10,.32);
    -webkit-transform: scale(1.019);
    -webkit-transform-origin: 0% 0;
  }
.zoom img{max-width:100%}

html, body {
  height: 100vh;
  margin: 0;
}
.wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* .content {
  flex: 1;
  overflow: auto;
 
} */
.nav-pills .nav-link {margin:2px;font-size: 13px !important;
background-color: #fff;}

.nav-pills .nav-link:hover {
  background-color: #e30613;
  color: #FFF;
}  
.nav-pills .nav-link:focus {
  background-color: #e30613!important;
  color: #FFF;
}  
.nav-pills .nav-link.active, .nav-pills .show > .nav-link
{
  background-color: #e30613!important;
  color: #FFF;
}
  
.flipx {
  transform: scaleX(-1);
  }


  .video-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
  }
  
  .video-responsive iframe {
    
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
  
  .form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-select~label {
  transform: scale(.85) translateY(-.5rem) translateX(.15rem)!important;
}

.form-check .form-check-input {
  margin-left: 0;
}

.yarl__container {
  background-color: var(--yarl__container_background_color,var(--yarl__color_backdrop,#000000ed))!important;
}

.overlayContainer{
  position: relative;
  margin: 0px;
}
.box{
  width: 100%;
  height: 100%;            
  position: absolute;
  top: 0;
  left: 0;
}
.stack-top{
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  margin: 0px; /* for demo purpose  */
}

.rotate {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.dropdown-toggle::after {
  display: none !important; 
}

.offcanvas {
  --bs-offcanvas-width: 22%;
}

.custom-dialog {
  position: fixed;
  top: auto;
  bottom:0;
  right: 25%;
  width:20% !important; }
  
.cropper-point,.cropper-line {
background-color: var(--bs-primary)!important ;
}

/* react tags input css*/
/* .rti--container {
  --rti-bg: "#fff",
  --rti-border: "#ccc",
  --rti-main: "#3182ce",
  --rti-radius: "0.375rem",
  --rti-s: "0.5rem",  spacing 
  --rti-tag: "#edf2f7",
  --rti-tag-remove: "#e53e3e"
} */
.rti--container {width:100%;padding:2px!important;--rti-radius: 0.25rem!important;}
.rti--input{padding:1px 2px!important;}
.rti--tag button {
  
  /* color:green!important;
  font-weight:bold!important; */
}
.rti--input:focus{border:0!important;}

.mapmarker g {
  cursor: pointer;
  transform: scale(1);
  transform-box: fill-box;
  /* transform-origin: center; */
  transition: all 0.3s ease;
  animation: circle .5s linear 1.3s forwards;
}
.mapmarker circle:hover{
  /* transform: scale(2); */
  
}
.mapmarker g:hover{
  z-index:1000;
  transform: scale(2);


}
.mapmarker circle img{
  /* clip-path: circle(40% at 50% 50%); */
}

.mapchart {
  position:relative;
}
.controls{
z-index: 9999999;
position: absolute;
top:0;
right:0;
margin:10px;
}

.ck.ck-editor__editable_inline p{
  margin-bottom:10px!important;
}

.post-content p{margin-bottom:10px!important;}

.infinite-scroll-component h6, .infinite-scroll-component div{
  text-align: center;
}

#whoswhoTabs li{margin-bottom:0}
.overlay-dark{background-color: rgba(0, 0, 0, 0.5)!important;overflow: hidden!important;
}

.input-group-vertical {
  margin-bottom: 10px;
  .form-control {
    border-radius: 0;
  }
  .form-group {
    margin-bottom: 0;
  }
  .form-group:not(:last-child) .form-control:not(:focus) {
    border-bottom-color: transparent;
  }
  .form-group:first-child .form-control {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .form-group:last-child .form-control {
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    top: -2px;
  }
}

.ck-balloon-panel{z-index:9999 !important}

:root{
  --ck-border-radius:6px!important;
}

.header-menu{
  position:relative;
  z-index: 2;
}
/* .swal2-popup .swal2-actions{
display:flex;
flex-direction: column;
  
  } */
  .swal-vertical{
    width: -moz-fit-content;
    width: fit-content;
    padding-left:10px;
    padding-right:10px;
  }
.swal-vertical .swal2-actions{
display:flex;
flex-direction: column;
font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,8BAA8B;IAC9B,kCAAkC;IAClC,mCAAmC;IACnC,mCAAmC;IACnC,sCAAsC;AAC1C;AACA;EACE,8CAA8C;EAC9C,uBAAuB;EACvB;AACF;AACA,yBAAyB,0BAA0B;AACnD,MAAM,SAAS;AACf,OAAO,cAAc;AACrB;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB,uEAAuE;AACvE;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yEAAyE;AAC3E;AACA;CACC,yEAAyE;AAC1E;AACA,OAAO,6BAA6B;AACpC,GAAG,wBAAwB;AAC3B,kBAAkB,sCAAsC,CAAC;AACzD;EACE,sEAAuL;AACzL;;AAEA,OAAO,yBAAyB,CAAC,0BAA0B,CAAC;AAC5D;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,kCAAkC;EAClC,yCAAyC;EACzC,8BAA8B;EAC9B,+CAA+C;EAC/C,qCAAqC;EACrC,UAAU,wBAAwB,CAAC,6BAA6B,CAAC,aAAa;;IAE5E,6BAA6B,cAAc;;IAE3C,gBAAgB,cAAc;IAC9B,aAAa,6CAA6C,EAAE;IAC5D,WAAW,iCAAiC,CAAC;;IAE7C;IACA,oBAAoB;IACpB,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,sCAAsC;IACtC,8CAA8C;IAC9C,uCAAuC;IACvC,2BAA2B;IAC3B,qCAAqC;IACrC,+CAA+C;IAC/C,4DAA4D;IAC5D,6BAA6B;IAC7B,uCAAuC;IACvC,iDAAiD;AACrD;AACA;EACE,4CAA4C;AAC9C;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,+EAA+E;EACjF;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,4BAA4B;IAC5B,6GAA6G;AACjH;EACE;IACE,2CAA2C;IAC3C,kDAAkD;IAClD,0BAA0B;IAC1B,8CAA8C;IAC9C,wDAAwD;IACxD,qCAAqC;IACrC,2BAA2B;IAC3B,+CAA+C;IAC/C,yDAAyD;IACzD,4DAA4D;IAC5D,oDAAoD;IACpD,iCAAiC;IACjC,2DAA2D;IAC3D,mBAAmB;EACrB;EACA;IACE,yDAAgD;EAClD;AACF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,gCAAgC;EAClC;IACE,sCAAsC;;IAEtC;MACE,oCAAoC;MACpC,wBAAwB;MACxB,QAAQ;IACV;IACA;MACE,oCAAoC;MACpC,wBAAwB;MACxB,QAAQ;IACV;IACA,aAAa,mDAAmD,EAAE;;IAElE;QACI,uBAAuB;IAC3B;GACD,WAAW,oCAAoC,CAAC;EACjD;MACI,4EAA4E;GAC/E;;;GAGA;IACC,oBAAoB;IACpB,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,sCAAsC;IACtC,8CAA8C;IAC9C,iDAAiD;IACjD,qCAAqC;IACrC,qCAAqC;IACrC,+CAA+C;IAC/C,sEAAsE;IACtE,uCAAuC;IACvC,uCAAuC;IACvC,iDAAiD;EACnD;EACA,MAAM,eAAe;EACrB;IACE,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,yDAA+C;EACjD;EACA;IACE,cAAc;IACd,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA,qBAAqB,oCAAoC,EAAE,UAAU;;AAEvE;;;AAGA;AACA,aAAa;AACb,2DAA2D;AAC3D,iBAAiB;AACjB;AACA;AACA,iBAAiB;AACjB,oCAAoC;AACpC,eAAe;AACf,aAAa;AACb,mBAAmB;AACnB;AACA;AACA,WAAW;AACX,cAAc;AACd,oBAAoB;AACpB,kBAAkB;AAClB;AACA;AACA,WAAW;AACX,kBAAkB;AAClB;;AAEA;IACI,UAAU;MACR,iBAAiB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;EACtB;EACA,oCAAoC,QAAQ,CAAC;;EAE7C,mCAAmC,gBAAgB,CAAC;;EAEpD,sBAAsB,gBAAgB,CAAC;EACvC,sBAAsB,gBAAgB,CAAC;EACvC,sBAAsB,gBAAgB,CAAC;EACvC,sBAAsB,gBAAgB,CAAC;EACvC,sBAAsB,gBAAgB,CAAC;EACvC,sBAAsB,gBAAgB,CAAC;;EAEvC;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;EACA,kBAAkB;EAClB,8CAA8C;AAChD;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA,eAAe,YAAY;AAC3B,WAAW,UAAU,EAAE,qBAAqB,CAAC;;AAE7C,kBAAkB,4BAA4B;;AAE9C;;AAEA;AACA;EACE,eAAe;AACjB;;AAEA,+BAA+B,aAAa,CAAC;AAC7C;EACE,oBAAoB;EACpB,oBAAoB;;AAEtB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;AACA,aAAa;AACb,mCAAmC;AACnC,gBAAgB;AAChB;AACA,aAAa,kBAAkB;;;;AAI/B;EACE,gBAAgB;AAClB;AACA,iBAAiB,kDAAkD,EAAE;;;AAGrE;EACE,4EAAkQ;AACpQ;AACA,6CAA6C,yBAAyB;AACtE,aAAa,yBAAyB;;AAEtC;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;;AAExB;AACA,mBAAmB,6BAA6B,CAAC;;AAEjD;EACE,eAAe;AACjB;AACA,eAAe,UAAU;;AAEzB,qBAAqB,wBAAwB;AAC7C;EACE,aAAa;EACb,sCAAsC;EACtC,iBAAiB;EACjB;;EAEA;IACE,aAAa;IACb,iCAAiC;IACjC,iBAAiB;IACjB;;EAEF;IACE,uCAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IAEE,6CAA6C;EAC/C;;EAEA;IACE,uBAAuB,EAAE,qFAAqF;IAC9G,sBAAsB;IAEtB,6CAA6C;IAC7C,+BAA+B;IAC/B,8BAA8B;EAChC;AACF,UAAU,cAAc;;AAExB;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;GAIG;AACH,sBAAsB,UAAU,CAAC,0BAA0B;AAC3D,sBAAsB,CAAC;;AAEvB;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,WAAW;AACb;AACA;;EAEE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB;;;EAGA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;;IAEE,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;;;EAGA,qEAAqE;AACvE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yGAAyG;AAC3G;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW,EAAE,sBAAsB;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,UAAU;EACV,oBAAoB,EAAE;;AAExB;AACA,8CAA8C;AAC9C;;AAEA,wBAAwB;AACxB;;;;;;;;GAQG;AACH,iBAAiB,UAAU,CAAC,qBAAqB,CAAC,+BAA+B,CAAC;AAClF,YAAY,yBAAyB,CAAC;AACtC;;EAEE;+BAC6B;AAC/B;AACA,kBAAkB,kBAAkB,CAAC;;AAErC;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,yBAAyB;;AAE3B;AACA;EACE,YAAY;EACZ,mBAAmB;;;AAGrB;AACA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;AACA;AACA,gBAAgB;AAChB,kBAAkB;AAClB,KAAK;AACL,OAAO;AACP,WAAW;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB,4BAA4B,CAAC;;AAE7C;EACE,kBAAkB;AACpB;;AAEA,gBAAgB,eAAe;AAC/B,cAAc,8CAA8C,CAAC,0BAA0B;AACvF;;AAEA;EACE,mBAAmB;EACnB;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA,kBAAkB,uBAAuB;;AAEzC;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;;;;KAIK;EACH;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA,YAAY;AACZ,sBAAsB;AACtB,eAAe;AACf","sourcesContent":[":root{\n    --bs-primary-rgb:227,6,19!important;\n    --bs-primary:#e30613!important;\n    --bs-body-font-size:1rem!important;\n    --bs-primary-rgb:227,6,19!important;\n    --bs-body-line-height:1.1!important;\n    --bs-link-color-rgb:227,6,19!important;    \n} \n.accordion-button:not(.collapsed){\n  background-color: rgba(227,6,19,0.2)!important;\n  color:#000000!important;\n  box-shadow: none!important\n}\n.accordion-button:focus {box-shadow: none!important}\n.w-90{width:91%}\n.vdots{z-index:999999}\n.vdots .dropdown-toggle::after {\n  display: none !important; \n}\n.bg-gradient-transparent{\n  background: rgb(0,0,0);\nbackground: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);\n}\n.dropdown-item.active, .dropdown-item:active {\n  background-color: var(--bs-primary)!important;\n}\n.nav-link{\n  font-size:16px!important;\n}\n.h1,h1,h2,h3,h4,h5,h6{\n  font-family: 'Barlow Medium', 'Arial Narrow', Arial, sans-serif!important;\n}\n.MuiButton-root{\n font-family: 'Barlow Medium', 'Arial Narrow', Arial, sans-serif!important;\n}\n.h6,h6{font-size: 0.813rem!important}\nh5{font-size:1rem!important}\n.card-img-overlay{background-color:transparent!important;}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2286b7fe%27/%3e%3c/svg%3e\")!important;\n}\n\nbody,p{line-height:1.1!important;font-size:0.9rem!important;}\n[data-bs-theme=light] {\n\n.MuiListItemButton-root, MuiListItemIcon-root {\n    color: var(--bs-black);\n    background-color: var(--bs-white);\n  }\n\n  --bs-link-color: #e30613!important;\n  --bs-link-color-rgb: 227, 6, 19!important;  \n  --bs-link-hover-color: #9c000a;\n  --bs-link-hover-color-rgb: 156, 0, 10!important;\n  --bs-primary-rgb:227, 6, 19!important;  \n  .btn.show{border:1px solid #e30613;background-color: transparent;color:#000000}\n\n    .navbar-nav .nav-link.active{color: #e30713}\n    \n    .nav-link:hover{color: #e30713}\n    .card:hover {box-shadow: 0 0 15px rgba(0,0,0,.3)!important; }\n    .bg-toggle{background-color: var(--bs-white);}    \n\n    .btn-primary{\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #e30713!important;\n    --bs-btn-border-color: #e30713!important;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #e30712da!important;\n    --bs-btn-hover-border-color: #ca200a!important;\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #ca270a!important;\n    --bs-btn-active-border-color: #be0d0a!important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: #fd2d0d!important;\n    --bs-btn-disabled-border-color: #fd0d0d!important;\n}\n.btn-light{\n  --bs-btn-bg:rgba(255,255,255,0.85)!important;\n}\n.text-primary {\n    color:#e30613!important;\n}\n\n.form-check-input:checked {\n    background-color: #e30713;\n    border-color: #e30713;\n  }\n  .text-bg-primary {\n    color: #fff !important;\n    background-color: RGBA(var(--bs-primary-rgb),var(--bs-bg-opacity,1)) !important;\n  }\n  .text-bg-heading {\n    color: var(--bs-gray-800);\n    font-weight: bold;\n    background: rgb(255,255,255);\n    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 51%, rgba(242,242,242,1) 90%);     \n}\n  .btn-outline-primary {\n    --bs-btn-color: var(--bs-primary)!important;\n    --bs-btn-border-color: var(--bs-primary)!important;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: var(--bs-primary)!important;\n    --bs-btn-hover-border-color: var(--bs-primary)!important;\n    --bs-btn-focus-shadow-rgb: 13,110,253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: var(--bs-primary)!important;\n    --bs-btn-active-border-color: var(--bs-primary)!important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: var(--bs-primary)!important;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: var(--bs-primary)!important;\n    --bs-gradient: none;\n  }\n  .content-container {\n    background-image: url('assets/img/bg-light.png');\n  }\n}\n\n[data-bs-theme=dark] {\n  \n  .MuiListItemButton-root, MuiListItemIcon-root {\n    color: var(--bs-white);\n    background-color: var(--bs-dark);\n  }\n    --bs-link-color-rgb:227,6,19!important;\n\n    .btn{\n      background-color: var(--bs-gray-900);\n      color:var(--bs-gray-300);\n      border:0;\n    }\n    .btn:hover{\n      background-color: var(--bs-gray-800);\n      color:var(--bs-gray-300);\n      border:0;\n    }\n    .card:hover {box-shadow: 0 0 15px rgba(255,255,255,.5)!important; }\n\n    .text-primary {\n        color:#e30613!important;\n    }\n   .bg-toggle{background-color: var(--bs-gray-900);}   \n  .bg-light{\n      background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n   }\n   \n\n   .btn-primary{\n    --bs-btn-color: #fff;\n    --bs-btn-bg: #e30713!important;\n    --bs-btn-border-color: #e30713!important;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #e30712da!important;\n    --bs-btn-hover-border-color: #ca200a!important;\n    --bs-btn-focus-shadow-rgb: 49, 132, 253!important;\n    --bs-btn-active-color: #fff!important;\n    --bs-btn-active-bg: #ca270a!important;\n    --bs-btn-active-border-color: #be0d0a!important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125)!important;\n    --bs-btn-disabled-color: #fff!important;\n    --bs-btn-disabled-bg: #fd2d0d!important;\n    --bs-btn-disabled-border-color: #fd0d0d!important;\n  }\n  .lead{color:aliceblue}\n  .form-check-input:checked {\n    background-color: #e30713;\n    border-color: #e30713;\n  }\n  .bg-header {\n    --bs-bg-opacity: 1;\n    background-color: var(--bs-black)!important;\n  }\n  .content-container {\n    background-image: url('assets/img/bg-dark.png');\n  }\n  .rti--container{\n    --rti-bg: none;\n    --rti-border: var(--bs-gray-700);\n  }\n  .rti--tag{\n    --rti-tag: var(--bs-gray-700);\n  }\n  .nav-pills .nav-link{background-color: var(--bs-gray-900); color:#ccc}\n  \n}\n\n\n.grid {\ndisplay: grid;\ngrid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\ngrid-gap: 0.25rem;\n}\n.grid > div {\nbackground: white;\nborder:1px solid  var(--bs-gray-300);\npadding: 0.1rem;\ndisplay: grid;\nplace-items: center;\n}\n.grid > div::before {\ncontent: \"\";\ndisplay: block;\npadding-bottom: 100%;\ngrid-area: 1/1/2/2;\n}\n.grid > div img {\nwidth: 100%;\ngrid-area: 1/1/2/2;\n}\n\n.slim-scrollbar {\n    padding: 0;\n      padding-left: 0px;\n    overflow-y: auto;\n    direction: ltr;\n    overflow-x: hidden;\n    scrollbar-color: #e30613 #e4e4e4;\n    scrollbar-width:none;\n  }\n  .slim-scrollbar::-webkit-scrollbar {width: 0;}\n \n  #sidebar .sidebar-left, #rsidebar {overflow: hidden;}\n  \n  .slim-scrollbar.mh-50{max-height: 50vh;}\n  .slim-scrollbar.mh-55{max-height: 57vh;}\n  .slim-scrollbar.mh-60{max-height: 60vh;}\n  .slim-scrollbar.mh-62{max-height: 62vh;}\n  .slim-scrollbar.mh-70{max-height: 70vh;}\n  .slim-scrollbar.mh-80{max-height: 80vh;}\n\n  small, .small {\n    font-size: 0.70em!important;\n    line-height: 1 !important;\n  }\n\n  .bg-header {\n  --bs-bg-opacity: 1;\n  background-color: var(--bs-gray-200)!important;\n}\n\n\n.nav-tabs .nav-link {\n  background-color: #ebebeb !important;\n  color: #000000 !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-bottom: solid 2px rgb(188, 188, 188) !important;\n}\n\n.nav-tabs .nav-link.active {\n  border-bottom: solid 2px rgb(227, 6, 19) !important;\n  background-color: #fff !important;\n}\n\n.ck-powered-by{display:none}\nfigure img{width:100%; height:auto!important;}\n\n.accordion-button{padding: 10px 10px!important}\n\n.hover-zoom {\n \n}\n.card-hover, .card-hover2{\n  overflow:hidden;\n}\n\n.card-hover2 .card-img-overlay{display: none;}\n.card-hover:hover img{\n  border:2px solid red;\n  transform:scale(1.2);\n\n}\n.card-hover2:hover .card-img-overlay{\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n}\n\n/* .modal-open {\n  overflow: scroll!important;\n} */\n\nhr.solid {\n  border-top: 4px solid #e30613;\n  width: 70px;\n  margin: auto;\n}\n.list-group-item.active {\ncolor:#000000;\nborder-color:var(--bs-border-color);\nbackground: #fff;\n}\nul li, ol li{margin-bottom:10px}\n\n\n\n#step1,#step2,#step3,#step4{\n  min-height: 85vh;\n}\noption:checked { box-shadow: 0 0 10px 100px var(--bs-primary) inset; } \n\n\n.form-check-input:checked[type=\"radio\"] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\") !important;\n}\n#uncontrolled-tab-example-tabpane-home ul li{margin-bottom:0!important}\n#step4 ul li{margin-bottom:0!important}\n\n.chat-button{\n  z-index:999999999999;\n  position: fixed!important;\n  right: 10px!important;\n  bottom: 10px!important;\n  \n}\n.chat-button:hover{box-shadow: 0px 0px 10px #ccc;}\n\n#libraryBanner:hover{\n  cursor: pointer;\n}\n#libraryBanner{width:100%}\n\n.MuiButton-startIcon{margin-right:0!important}\n.profile-grid {\n  display: grid;\n  grid-template-columns:  auto auto auto; \n  grid-gap: 0.75rem;\n  }\n\n  .profile-grid-2-cols {\n    display: grid;\n    grid-template-columns:  auto auto; \n    grid-gap: 0.75rem;\n    }\n  \n  .bic-rounded-top {\n    border-top-left-radius: 15px !important;\n    border-top-right-radius: 15px !important;\n  }\n\n  .zoom {\n    -webkit-box-shadow: 20px 20px 41px rgba(10,10,10,.15);\n    box-shadow: 20px 20px 41px rgba(10,10,10,.15);\n  }\n\n  .zoom:hover {\n    transform: scale(1.019); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n    transform-origin: 0% 0;\n    -webkit-box-shadow: 20px 20px 41px rgba(10,10,10,.32);\n    box-shadow: 20px 20px 41px rgba(10,10,10,.32);\n    -webkit-transform: scale(1.019);\n    -webkit-transform-origin: 0% 0;\n  }\n.zoom img{max-width:100%}\n\nhtml, body {\n  height: 100vh;\n  margin: 0;\n}\n.wrapper {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* .content {\n  flex: 1;\n  overflow: auto;\n \n} */\n.nav-pills .nav-link {margin:2px;font-size: 13px !important;\nbackground-color: #fff;}\n\n.nav-pills .nav-link:hover {\n  background-color: #e30613;\n  color: #FFF;\n}  \n.nav-pills .nav-link:focus {\n  background-color: #e30613!important;\n  color: #FFF;\n}  \n.nav-pills .nav-link.active, .nav-pills .show > .nav-link\n{\n  background-color: #e30613!important;\n  color: #FFF;\n}\n  \n.flipx {\n  transform: scaleX(-1);\n  }\n\n\n  .video-responsive {\n    overflow: hidden;\n    padding-bottom: 56.25%;\n    position: relative;\n    height: 0;\n  }\n  \n  .video-responsive iframe {\n    \n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n  }\n  \n  .form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-select~label {\n  transform: scale(.85) translateY(-.5rem) translateX(.15rem)!important;\n}\n\n.form-check .form-check-input {\n  margin-left: 0;\n}\n\n.yarl__container {\n  background-color: var(--yarl__container_background_color,var(--yarl__color_backdrop,#000000ed))!important;\n}\n\n.overlayContainer{\n  position: relative;\n  margin: 0px;\n}\n.box{\n  width: 100%;\n  height: 100%;            \n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.stack-top{\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin: 0px; /* for demo purpose  */\n}\n\n.rotate {\n  animation: rotation 2s infinite linear;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.dropdown-toggle::after {\n  display: none !important; \n}\n\n.offcanvas {\n  --bs-offcanvas-width: 22%;\n}\n\n.custom-dialog {\n  position: fixed;\n  top: auto;\n  bottom:0;\n  right: 25%;\n  width:20% !important; }\n  \n.cropper-point,.cropper-line {\nbackground-color: var(--bs-primary)!important ;\n}\n\n/* react tags input css*/\n/* .rti--container {\n  --rti-bg: \"#fff\",\n  --rti-border: \"#ccc\",\n  --rti-main: \"#3182ce\",\n  --rti-radius: \"0.375rem\",\n  --rti-s: \"0.5rem\",  spacing \n  --rti-tag: \"#edf2f7\",\n  --rti-tag-remove: \"#e53e3e\"\n} */\n.rti--container {width:100%;padding:2px!important;--rti-radius: 0.25rem!important;}\n.rti--input{padding:1px 2px!important;}\n.rti--tag button {\n  \n  /* color:green!important;\n  font-weight:bold!important; */\n}\n.rti--input:focus{border:0!important;}\n\n.mapmarker g {\n  cursor: pointer;\n  transform: scale(1);\n  transform-box: fill-box;\n  /* transform-origin: center; */\n  transition: all 0.3s ease;\n  animation: circle .5s linear 1.3s forwards;\n}\n.mapmarker circle:hover{\n  /* transform: scale(2); */\n  \n}\n.mapmarker g:hover{\n  z-index:1000;\n  transform: scale(2);\n\n\n}\n.mapmarker circle img{\n  /* clip-path: circle(40% at 50% 50%); */\n}\n\n.mapchart {\n  position:relative;\n}\n.controls{\nz-index: 9999999;\nposition: absolute;\ntop:0;\nright:0;\nmargin:10px;\n}\n\n.ck.ck-editor__editable_inline p{\n  margin-bottom:10px!important;\n}\n\n.post-content p{margin-bottom:10px!important;}\n\n.infinite-scroll-component h6, .infinite-scroll-component div{\n  text-align: center;\n}\n\n#whoswhoTabs li{margin-bottom:0}\n.overlay-dark{background-color: rgba(0, 0, 0, 0.5)!important;overflow: hidden!important;\n}\n\n.input-group-vertical {\n  margin-bottom: 10px;\n  .form-control {\n    border-radius: 0;\n  }\n  .form-group {\n    margin-bottom: 0;\n  }\n  .form-group:not(:last-child) .form-control:not(:focus) {\n    border-bottom-color: transparent;\n  }\n  .form-group:first-child .form-control {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n  }\n  .form-group:last-child .form-control {\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px;\n    top: -2px;\n  }\n}\n\n.ck-balloon-panel{z-index:9999 !important}\n\n:root{\n  --ck-border-radius:6px!important;\n}\n\n.header-menu{\n  position:relative;\n  z-index: 2;\n}\n/* .swal2-popup .swal2-actions{\ndisplay:flex;\nflex-direction: column;\n  \n  } */\n  .swal-vertical{\n    width: fit-content;\n    padding-left:10px;\n    padding-right:10px;\n  }\n.swal-vertical .swal2-actions{\ndisplay:flex;\nflex-direction: column;\nfont-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
